<div class="spinner">
  <div class="bounce1"></div>
  <div class="bounce2"></div>
  <div class="bounce3"></div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/campaigns-add/spinner/spinner.component.html